import React, { createContext, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [workData, setWorkData] = useState([]);
  const [workCategoryData, setWorkCategoryData] = useState([]);
  const [error, setError] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [sliderImages, setSliderImages] = useState([]);
  const [mediaData, setMediaData] = useState({});

  return (
    <UserContext.Provider
      value={{
        isLoading,
        workData,
        workCategoryData,
        error,
        images,
        selectedCategoryId,
        sliderImages,
        setSliderImages,
        mediaData,
        setMediaData,
        setWorkData,
        setWorkCategoryData,
        setImages,
        setIsLoading,
        setSelectedCategoryId,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
